import React, { useState, useCallback, createContext } from "react";

export const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const LoadingData = (isLoading)=>{
    setLoading(isLoading);
  }
  const contextValue = {
    loading,
    showLoading: useCallback((request) => {
      LoadingData(request);
    }, []),
  };

  return (
    <LoaderContext.Provider value={contextValue}>
      {children}
    </LoaderContext.Provider>
  );
};
